<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>led</title>
      <path fill="#679940"
        d="M30,5H2A1,1,0,0,0,1,6V26a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1V6A1,1,0,0,0,30,5ZM29,25H3V7H29Z"
      />
      <circle fill="#679940" cx="5.5" cy="10" r="1" />
      <circle fill="#679940" cx="9.7" cy="10" r="1" />
      <circle fill="#679940" cx="13.9" cy="10" r="1" />
      <circle fill="#679940" cx="18.1" cy="10" r="1" />
      <circle fill="#679940" cx="22.3" cy="10" r="1" />
      <circle fill="#679940" cx="26.5" cy="10" r="1" />
      <circle fill="#679940" cx="5.5" cy="14" r="1" />
      <circle fill="#679940" cx="9.7" cy="14" r="1" />
      <circle fill="#679940" cx="13.9" cy="14" r="1" />
      <circle fill="#679940" cx="18.1" cy="14" r="1" />
      <circle fill="#679940" cx="22.3" cy="14" r="1" />
      <circle fill="#679940" cx="26.5" cy="14" r="1" />
      <circle fill="#679940" cx="5.5" cy="18" r="1" />
      <circle fill="#679940" cx="9.7" cy="18" r="1" />
      <circle fill="#679940" cx="13.9" cy="18" r="1" />
      <circle fill="#679940" cx="18.1" cy="18" r="1" />
      <circle fill="#679940" cx="22.3" cy="18" r="1" />
      <circle fill="#679940" cx="26.5" cy="18" r="1" />
      <circle fill="#679940" cx="5.5" cy="22" r="1" />
      <circle fill="#679940" cx="9.7" cy="22" r="1" />
      <circle fill="#679940" cx="13.9" cy="22" r="1" />
      <circle fill="#679940" cx="18.1" cy="22" r="1" />
      <circle fill="#679940" cx="22.3" cy="22" r="1" />
      <circle fill="#679940" cx="26.5" cy="22" r="1" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "LedscreenIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/LedscreenIcon.vue